import slideOne from '../images/slide-1.jpg';
import slideTwo from '../images/slide-2.jpg';
import slideThree from '../images/slide-3.jpg';
import slideFour from '../images/slide-4.jpg';
import slideFive from '../images/slide-5.jpg';

const sliderData = [
  {
    image: slideOne,
    heading: 'Notre Mission',
    desc: 'Nous sommes appelés à travailler sur le retour dans le vrai sacerdoce.',
  },
  {
    image: slideFour,
    heading: 'Notre Vision',
    desc: "L'Implentation des églises dans d'autres coins et recoins du monde par rapport à l'orientation du Saint - Esprit.",
  },
  {
    image: slideThree,
    heading: '2 Timothée 2:2',
    desc: "\"Et ce que tu as entendu de moi en présence de beaucoup de témoins, confie-le à des hommes fidèles, qui soient capables de l'enseigner aussi à d'autres.\"",
  },
  {
    image: slideTwo,
    heading: "L'adoration",
    desc: "Nous informons et formons les gens afin qu'ils deviennent des vrais adorateurs qui adorent le Père en esprit et en vérité.",
  },
  {
    image: slideFive,
    heading: 'Les affermissements',
    desc: "Nous affermissons afin que la personne devienne un Chrétien pratiquant  vivant dans la chrétienneté. Et cela au travers d'ample formation ou enseignement bien structuré.",
  },
];

export default sliderData;
